import { UserCog } from 'lucide-react';
import { IconSectionHeader } from '@/components/shared/IconSectionHeader';
import { ActionRow } from '@reflex/ui/components/shared/ActionRow';
import { MonoBadge } from '@/components/shared/MonoBadge';
import type { PluginManifest } from '@/lib/plugin-registry';

type ServiceAccount = NonNullable<NonNullable<PluginManifest['server']>['serviceAccounts']>[number];

export function PluginServiceAccountsSection({
  serviceAccounts,
}: {
  serviceAccounts: ServiceAccount[];
}) {
  if (serviceAccounts.length === 0) return null;

  return (
    <section data-testid="plugin-detail-section-service-accounts">
      <IconSectionHeader icon={UserCog}>Service Accounts</IconSectionHeader>
      <div className="divide-y rounded-lg border">
        {serviceAccounts.map((sa) => (
          <ActionRow
            key={sa.id}
            data-testid={`plugin-service-account-row-${sa.id}`}
            title={sa.name}
            meta={
              <>
                <MonoBadge>{sa.id}</MonoBadge>
                <span className="font-mono text-xs text-muted-foreground">{sa.login}</span>
              </>
            }
          />
        ))}
      </div>
    </section>
  );
}
